import new_germany from "../images/newProductPage/languages/DE.png";
import new_spanish from "../images/newProductPage/languages/ES.png";
import new_french from "../images/newProductPage/languages/FR.png";
import new_italy from "../images/newProductPage/languages/IT.png";
import new_niderland from "../images/newProductPage/languages/ND.png";
import new_polish from "../images/newProductPage/languages/PL.png";
import new_portugal from "../images/newProductPage/languages/PR.png";
import new_russia from "../images/newProductPage/languages/RU.png";
import new_LTgland from "../images/newProductPage/languages/UK.png";

import screen1 from "../images/newProductPage/lithuanian/1.png";
import screen2 from "../images/newProductPage/lithuanian/2.png";
import screen3 from "../images/newProductPage/lithuanian/3.png";
import screen4 from "../images/newProductPage/lithuanian/4.png";

import dlaczego1 from "../images/newProductPage/why/dlaczego_1.webp";
import dlaczego2 from "../images/newProductPage/why/dlaczego_2.webp";
import dlaczego3 from "../images/newProductPage/why/dlaczego_3.webp";

import zdjecie2 from "../images/newProductPage/mission/latop_square.png";
import zdjecie3 from "../images/newProductPage/mission/people_square.png";
import zdjecie1 from "../images/newProductPage/mission/women_square.png";

export const lithuanian = {
  navbar: {
    data: [
      { title: "Užsisakyti kursą", path: "/course" },
      { title: "Prisijungti", path: "/start" },
      { title: "kalbigo", path: "/" },
      { title: "Apie mus", path: "/about" },
      { title: "Atsiliepimai", path: "/reviews" },
    ],
  },
  mainPage: {
    product_page: {
      language: "lt",
      hero: {
        languages: [
          "anglų kalba",
          "ispanų kalba",
          "vokiečių kalba",
          "olandų kalba",
          "italų kalba",
          "rusų kalba",
          "lenkų kalba",
          "prancūzų kalba",
          "portugalų kalba",
        ],
        title: "Kalbėk drąsiai,",
        prefix: "pasitikėdamas savimi",
        subtitle:
          "Įgykite kalbos įgūdžių per mūsų kursą, paremtą tikrais gyvenimo pavyzdžiais!",
        buttonText: "Užsisakyti dabar!",
      },
      learning: {
        title: "Kaip atrodo kursas?",
        config: [
          {
            image: screen1,
            category: "Išmokite kalbą lengviausiu būdu",
            descriptions: [
              {
                bold: "Dešimtys pamokų",
                rest: "su pavyzdžiais, pagrįstais kasdieniu bendravimu.",
              },
              {
                bold: "Praktiškos frazės",
                rest: "sukurtos gimtakalbių kalbėtojų.",
              },
              {
                bold: "Pratimai,",
                rest: "kurie efektyviai lavina skaitymo, klausymo ir kalbėjimo įgūdžius.",
              },
            ],
          },
          {
            image: screen2,
            category: "Praktinės pamokos",
            description:
              "Kiekviename mokymosi lygyje yra dešimtys pamokų, pritaikytų jūsų poreikiams.",
          },
          {
            image: screen3,
            category: "Užduotys",
            description:
              "Mūsų pratimai efektyviai padeda kartoti medžiagą ir gerinti atmintį.",
          },
          {
            image: screen4,
            category: "Žodžiai, frazės ir išraiškos",
            description:
              "Kiekviena pamoka apima kruopščiai atrinktus vaizdus, kurie daro mokymosi procesą intuityvų.",
          },
        ],
        photoData: [screen1, screen2, screen3, screen4],
      },
      languages: {
        languages: [
          { image: new_LTgland, lang: "Anglų" },
          { image: new_french, lang: "Prancūzų" },
          { image: new_spanish, lang: "Ispanų" },
          { image: new_niderland, lang: "Olandų" },
          { image: new_germany, lang: "Vokiečių" },
          { image: new_italy, lang: "Italų" },
          { image: new_russia, lang: "Rusų" },
          { image: new_portugal, lang: "Portugalų" },
          { image: new_polish, lang: "Lenkų" },
        ],
        title: "Prieinamos kalbos:",
        description:
          "Pasiruoškite savo kitai kelionei arba pridėkite kalbos įgūdžių į savo CV.",
      },
      expertSection: {
        title: "Jūsų kalbos ekspertas",
        firstSectionTitle: "Pagalba pasiekiama ranka",
        firstSectionDescription: "Gaukite visą palaikymą mokymosi metu!",
        secondSectionTitle: "Užduokite klausimus ir gaukite atsakymus",
        secondSectionDescription:
          "Bet kokius klausimus galite užduoti tiesiogiai savo ekspertui.",
        thirdSectionTitle: "Individualus požiūris kiekviename žingsnyje",
        thirdSectionDescription:
          "Eksperto patarimų naudojimas pagreitina jūsų mokymąsi.",
      },
      courseValue: {
        title: "Gaukite daugiau su KalbiGo",
        subtitle:
          "Ne tik kalbos mokymasis – gaukite visą prieigą prie įrankių.",
        buttonText: "Užsisakyti dabar!",
        config: [
          {
            title: "Mokymasis, pritaikytas jūsų gyvenimo būdui",
            sections: [
              {
                text: "Mokykitės, kur norite ir kada norite, naudodamiesi mūsų platforma.",
              },
              {
                text: "Trumpi pamokos puikiai įsilieja į jūsų kasdienį tvarkaraštį.",
              },
            ],
          },
          {
            title: "Motyvacija kiekviename žingsnyje",
            sections: [
              {
                text: "Išlaikykite savo mokymosi tempą naudodami mūsų sekimo sistemą.",
              },
              {
                text: "Kiekviena mokymosi diena priartina jus prie kalbos laisvumo.",
              },
            ],
          },
          {
            title: "Visiškas lankstumas ir personalizavimas",
            sections: [
              {
                text: "Prisitaikykite kursą pagal savo lygį ir mokymosi tempą.",
              },
              {
                text: "Sutelkkite dėmesį į tai, kas jus labiausiai domina.",
              },
            ],
          },
        ],
      },
      faq: {
        title: "Dažniausiai užduodami klausimai",
        subtitle: "Turite klausimų? Mes turime atsakymus.",
        sections: [
          {
            title: "Apie KalbiGo",
            questions: [
              {
                question: "Kas yra „KalbiGo“?",
                answer:
                  "„KalbiGo“ – tai internetinė užsienio kalbų mokymosi platforma, leidžianti greitai ir efektyviai įgyti kalbėjimo bei klausymo įgūdžių praktikoje.",
              },
              {
                question: "Kā darbojas Runava valodu kursi?",
                answer:
                  "Užsiregistravus, gausite prieigą prie interaktyvių internetinių pamokų ir medžiagos, kurią galėsite naudoti jums patogiu laiku. Kursai pritaikomi prie jūsų lygio ir tikslų.",
              },
              {
                question: "Ar „KalbiGo“ tikrai padeda išmokti kalbėti?",
                answer:
                  "Taip. Mūsų kursai orientuoti į praktinę komunikaciją – interaktyvios užduotys padės greitai įveikti kalbėjimo barjerą.",
              },
            ],
          },
          {
            title: "Mokėjimai ir pristatymas",
            questions: [
              {
                question: "Kaip galiu sumokėti už „KalbiGo“ kursą?  ",
                answer:
                  "Galite atsiskaityti internetu arba pristatymo metu, atsiimdami siuntą iš kurjerio.",
              },
              {
                question: "Ar mano duomenys ir mokėjimai yra saugūs?",
                answer:
                  "Taip. Visi duomenys apsaugoti pagal BDAR, o mokėjimai – tiek internetu, tiek pristatymo metu – yra užtikrinami patikimų partnerių.",
              },
              {
                question: "Ar atsiskaitymas pristatymo metu yra saugus?",
                answer:
                  "Taip. Kurjeris pristato siuntą, o mokėjimas atliekamas saugiai jos atsiėmimo metu.",
              },
              {
                question:
                  "Kada gausiu prieigą prie kurso po užsakymo apmokėjimo?",
                answer:
                  "Prieiga aktyvuojama automatiškai, įvedus kodą nurodytoje svetainėje.",
              },
              {
                question: "Kas bus, jei neatsiimsiu siuntos?",
                answer:
                  "Jeigu neatsiimsite siuntos, prieiga prie kurso nebus aktyvuota. Tačiau kursą galėsite užsisakyti dar kartą jums patogiu metu.",
              },
            ],
          },
          {
            title: "Saugumas, pasitikėjimas ir pagalba",
            questions: [
              {
                question: "Ar mano asmens duomenys „KalbiGo“ yra saugūs?",
                answer:
                  "Taip. Naudojame šifravimą ir duomenų apsaugos standartus, atitinkančius Europos Sąjungos reikalavimus.",
              },
              {
                question: "Ar „KalbiGo“ yra legali ir registruota įmonė?",
                answer:
                  "Taip. „KalbiGo“ – tai edukacinis prekės ženklas, priklausantis įmonei „European Learning Agency“, kuri veikia teisėtai ir yra registruota Europos Sąjungoje. Išsamią informaciją apie įmonę ir registraciją rasite mūsų svetainėje pateiktuose nuostatuose.",
              },
              {
                question:
                  "Kaip galiu susisiekti su „KalbiGo“ klientų aptarnavimu?",
                answer:
                  "Galite parašyti el. paštu kas@kalbigo-edu.com arba naudotis kontaktine forma, pateikta mūsų svetainėje.",
              },
              {
                question:
                  "Ar siūlote pasitenkinimo garantiją arba pinigų grąžinimą?",
                answer:
                  "Taip. Jei kursas neatitinka jūsų lūkesčių, siūlome galimybę atsisakyti ar susigrąžinti pinigus pagal nuostatus – be jokios rizikos.",
              },
            ],
          },
        ],
      },
    },
  },
  aboutUs: {
    hero: {
      title: "Misija",
      description: `Mūsų pagrindinis tikslas KalbiGo yra kiekvienam žmogui suteikti galimybę turėti asmeninį mokytoją naudojantis technologijomis. Tikime, kad kalba – tiltas tarp kultūrų, ir mūsų misija yra įveikti bendravimo kliūtis bei suburti žmones pasitelkus kalbų mokymąsi.`,
    },
    why: {
      title: "Kodėl mes?",
      config: [
        {
          title: "Pažangūs mokymo metodai",
          image: dlaczego1,
          description:
            "Mūsų modernus ir praktika patikrintas mokymosi algoritmas mokymo medžiagą pritaiko prie jūsų esamo žinių lygio ir jį didina teikiant efektyvų mokymą.",
        },
        {
          title: "Didelis kalbų pasirinkimas",
          image: dlaczego2,
          description:
            "Siūlome pasaulyje daugiausiai vartojamų kalbų kursus, tad galite pasirinkti kalbą, atitinkančią jūsų poreikius.",
        },
        {
          title: "Mokymasis smagiai",
          image: dlaczego3,
          description:
            "Mūsų platforma kalbos mokymąsi paverčia smagia ir malonia patirtimi, tad būsite motyvuoti jį tęsti.",
        },
      ],
    },
    mission: {
      config: [
        {
          title: "Pritaikymas prie individualių poreikių ir prieiga",
          description:
            "Mūsų galingas mašininio mokymosi algoritmas nuolat pluša, kad pateiktų kiekvienam asmeniui tinkamo lygio mokymosi medžiagą. KalbiGo besimokantiesiems leidžia patiems rasti kalbos modelius, dėmesio nesutelkiant į  taisykles – tuo pačiu būdu, kaip vaikystėje išmokote savo gimtosios kalbos.",
          image: zdjecie1,
        },
        {
          title: "Drąsus technologijų ir mokslo derinys",
          description:
            "KalbiGo drąsiai derinamos technologijos ir mokslas, taip siekiant sužadinti jūsų protą veiklai. Kartoti nesuskaičiuojamą daugybę žodžių ir frazių sąrašų yra nuobodu ir jūsų smegenys tai žino. Mūsų metodas, kuriuo esate verčiami įvairiais būdais įgytas žinias panaudoti konkrečiu metu, yra įdomus ir veiksmingas – jūsų smegenys tai įvertins!",
          image: zdjecie2,
        },
        {
          title: "Bendruomenė ir vertybės",
          description:
            "Kalbos padeda žmonėms užmegzti ryšius. Kalbų mokymasis skatina supratimą. KalbiGo bendruomenė suburia žmones iš viso pasaulio. Esame ambicingi ir visad plečiame ribas. Manome, kad mokytis kalbų turėtų būti smagu, ir mus domina pažinti naujas kultūras pasitelkus kalbas.",
          image: zdjecie3,
        },
      ],
    },
  },
  formSender: {
    formControll: {
      pageLink: "https://nyelvfejlesztesi-kozpont.eu/",
      title: "Susidomėjote kursu?",
      title1: "Norėtumėte daugiau informacijos?",
      subtitle: "Palikite savo telefono numerį ir mes jums paskambinsime.",
      subtitle1:
        "If you already have an account, please fill in the following fields:",
      button1: "Vardas ir pavardė",
      button2: "Telefono numeris",
      button3: "El. paštas",
      buttonSub: "Pateikti užklausą skambučiui",
      checkOne:
        "Pateikdamas šią formą sutinku su sąlygomis ir pareiškiu, kad susipažinau su sąlygomis ir duomenų apsaugos taisyklėmis.",
      checkOneTwo: "",
      checkTwo: "Sutinku, kad su manimi susisiektų rinkodaros reikmėms",
      textOne: "Pranešame, kad jūsų asmens duomenų valdytojas yra",
      textTwo:
        "ELA Sp. z o.o., kurio būstinė yra Varšuvoje, ul. Młynarska 42 / 115, 01-171, įregistruotas Varšuvos apygardos teismo tvarkomame verslininkų registre numeriais KRS 0001038089, REGON 525396900, NIP 5273057993. Jūsų asmens duomenys bus tvarkomi dėl kontaktinės formos užklausos arba sudarytos sutarties vykdymo. Susisiekdami su mumis savanoriškai sutinkate, kad jūsų asmens duomenys būtų tvarkomi minėtais tikslais. Turite teisę su savo duomenimis susipažinti, juos ištaisyti, ištrinti ar apriboti jų tvarkymą, nesutikti, kad jie būtų tvarkomi, ir teisę į duomenų perkeliamumą. Taip pat turite teisę bet kada atšaukti savo sutikimą, tačiau sutikimo atšaukimas neturi įtakos duomenų tvarkymo, grindžiamo sutikimu iki atšaukiant, teisėtumui. Be to, turite teisę pateikti skundą priežiūros institucijai. Duomenų pateikimas yra savanoriškas, tačiau gali būti privalomas norint atsakyti į užklausą arba įvykdyti sutartį. Asmens duomenys bus saugomi tol, kol tai bus būtina siekiant pirmiau nurodytų tikslų, bet ne ilgiau nei pagal bendrąją teisę nustatytą reikalavimų senaties terminą. Prašome atidžiai perskaityti privatumo politiką.",
      buttonMore: "Skaityti daugiau",
      buttonLess: "Skaityti mažiau",
      subOne: "Paslaugų teikimo sąlygos",
      subTwo: "ir privatumo taisykles.",
      buttonTXT: "Thank you",
      rulesLink: "/Regulations_LT.pdf",
      privacyLink: "/Privacy_LT.pdf",
      product: "kl",
      market: "lt",
      send_to_url: "https://crm.eou-edu.eu/api/v1/cms/create_order",
      utm_source: "Platform_kalbigo",
      product_variant: "lt-en",
      server_link: "https://cms.eou-assets.eu/integration/lead-from-landing",
      currency: "eur",
      price: 87,
    },
  },
  reviews: {
    language: "lt",
    title: "KalbiGo Atsiliepimai",
    subtitle:
      "Tavo nuomonė svarbi - KalbiGo atsiliepimai padeda mums plėtoti platformą pagal vartotojų poreikius.",
    contentPlaceholder: "Pradėk rašyti",
    submitButton: "Siųsti",
    thankYouText:
      "Dėkojame, kad dalinatės savo patirtimi ir kartu su mumis kuriate efektyvią kalbų mokymosi priemonę!",
    recommendedLabel: "Rekomenduojama",
    items: [
      {
        text: "Mokymo metodas puikus, toli pralenkia tai, ką sutikau kitose platformose.",
        isRecommended: true,
      },
      {
        text: "Dėl interaktyvių pratimų greitai pažengiau. Drąsiai rekomenduoju kiekvienam, kas nori tikrų rezultatų.",
        isRecommended: true,
        isLarge: true,
      },
      {
        text: "Labai intuityvi platforma. Pripratau prie jos nuo pirmųjų minučių be jokios pagalbos.",
        isRecommended: true,
      },
      {
        text: "Techninė pagalba greita. Šiame procese nė sekundės nesijaučiau vienas.",
        isRecommended: true,
      },
      {
        text: "Medžiaga ypač gerai struktūruota ir suteikia aiškų vaizdą apie mokymosi procesą. Kiekviena pamoka logiškai seka po ankstesnės, todėl pažanga labai natūrali ir intuityvi. Paaiškinimai išsamūs, o praktiniai pavyzdžiai labai padeda įtvirtinti žinias, paversdami mokymąsi malonia ir ilgalaike efektyvia patirtimi.",
        isRecommended: true,
        isTall: true,
      },
      {
        text: "Lankstumas – didžiausias privalumas. Galiu mokytis bet kada, bet kur, bet kuriame įrenginyje.",
        isRecommended: true,
      },
      {
        text: "Dizainas malonus akims. Galiu mokytis valandų valandas nepavargdamas.",
        isRecommended: true,
      },
      {
        text: "Žodyną pagerinau per rekordiškai trumpą laiką. Viskas labai praktiška.",
        isRecommended: true,
      },
      {
        text: "Iš tikrųjų šiuolaikinė mokymosi patirtis. Tai padėjo man įveikti baimę kalbėti užsienio kalba.",
        isRecommended: true,
        isLarge: true,
      },
      {
        text: "Kursų garso kokybė nepriekaištinga, o tai būtina teisingam supratimui.",
        isRecommended: true,
      },
      {
        text: "Žaidybinimo sistema motyvuoja grįžti kasdien ir nuolat tobulėti.",
        isRecommended: true,
      },
      {
        text: "Nuostabu, kaip matai matomą pažangą savaitė po savaitės. Investicija to verta!",
        isRecommended: true,
      },
      {
        text: "Sąsaja švari, be reklamų ir elementų, kurie atitrauktų nuo mokymosi.",
        isRecommended: true,
      },
      {
        text: "Bendruomenė labai aktyvi ir draugiška. Visada rasi atsakymus į klausimus.",
        isRecommended: true,
      },
    ],
  },
  footer: {
    title: "Prisijunkite prie mūsų čia:",
    privacy: "Privatumas",
    privacyLink: "/Privacy_LT.pdf",
    rules: "Paslaugų teikimo sąlygos",
    rulesLink: "/Regulations_LT.pdf",
  },
};
